
<template>
  <div id="app">
	  <div v-cloak>
       <PracticeBallotV2 />

	  </div>
 
	  
  </div>

 
</template>


<script>

import PracticeBallotV2 from './PracticeBallotV2'
import   '../styles/main.css'

export default {
  name: "App",
  components: {
  "PracticeBallotV2":  PracticeBallotV2,
  },
};
</script>




// WEBPACK FOOTER //
// src/App.vue